import { languageDisplayLabel, LanguagesEnum } from '@/api/enums';
import { ContentSeries } from '@/client/courses';
import { FilterNamesEnum } from '@/client/helpers';
import { TranslationFunctionType } from '@/common/types';
import { FilterType, FilterTypeEnum } from '@/components/tables/crud';

export const coursesFilters = (t: TranslationFunctionType): FilterType[] => [
  {
    label: t('content.custom.content'),
    field: FilterNamesEnum.COURSE_CUSTOM_CONTENT,
    placeholder: t('content.custom.content'),
    type: FilterTypeEnum.SELECT_YES_NO,
  },
  {
    label: t('content.tags'),
    field: FilterNamesEnum.COURSE_TAGS,
    placeholder: t('content.tags'),
    type: FilterTypeEnum.MULTI_SELECT,
  },
  {
    label: t('content.series'),
    field: FilterNamesEnum.COURSE_SERIES,
    placeholder: t('content.series'),
    type: FilterTypeEnum.MULTI_SELECT,
    options: Object.values(ContentSeries)
      .map((series) => ({
        label: t(`content.series.${series}`),
        value: series,
      }))
      .concat({
        label: t('content.series.blank'),
        value: null as unknown as ContentSeries,
      }),
  },
  {
    label: t('generic.lang'),
    field: FilterNamesEnum.COURSE_LANGUAGES,
    placeholder: t('generic.lang'),
    type: FilterTypeEnum.MULTI_SELECT,
    options: Object.values(LanguagesEnum).map((language) => ({
      label: languageDisplayLabel[language],
      value: language,
    })),
  },
  {
    label: t('content.clonable'),
    field: FilterNamesEnum.COURSE_CLONABLE,
    placeholder: t('content.clonable'),
    type: FilterTypeEnum.SELECT_YES_NO,
  },
  {
    label: t('content.aiCustomizable'),
    field: FilterNamesEnum.COURSE_AI_CUSTOMIZABLE,
    placeholder: t('content.aiCustomizable'),
    type: FilterTypeEnum.SELECT_YES_NO,
  },
];
